import CrecheLife from "./CrecheLife.jsx";

export default CrecheLife;